import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class VertreterFilterService {
  readonly vertreterFilterActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
